import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const RolesLayout = lazy(() => import('@/pages/roles/layout'));
const RolesListPage = lazy(() => import('@/pages/roles'));
const RoleCreatePage = lazy(() => import('@/pages/roles/create'));
const RoleUpdatePage = lazy(() => import('@/pages/roles/update'));

/**
 * UG-4500 — role entity routes (legacy `app/(dashboard)/roles/*`).
 * Permissions: `@/config/auth/routeAccess` (`/roles`, `/roles/create`,
 * `/roles/[id]/update`). `RolesLayout` mounts the section breadcrumb
 * (UG-4513).
 */
export const roleRoutes: RouteConfig = {
  path: '/roles',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: RolesLayout,
      children: [
        { path: '', element: RolesListPage },
        { path: '/create', element: RoleCreatePage },
        { path: '/:roleId/update', element: RoleUpdatePage },
      ],
    },
  ],
};
